import React from "react";
import ImagePartitionLayout from "../../layout/imagepartitionlayout/imagepartitionlayout";

import AuthenticationContainer from "../../components/AuthenticationContainer/authenticationcontainer";

import ConfirmOTPResetPasswordForm from "./components/confirmotpresetpasswordform";
import {RESET_SUBTITLE, WEBSITE_TITLE} from "../../constants/appconstants";

class ConfirmOTPResetPassword extends React.Component {
    render() {
        return (
            <ImagePartitionLayout ContentComponent={ <AuthenticationContainer  Component={<ConfirmOTPResetPasswordForm/>} titleLabel={"Reset Password"}/>}
                                  title={WEBSITE_TITLE}
                                  subtitle={
                                      ""}
            />
        );
    }
}

export default ConfirmOTPResetPassword;



